<div class="jumbotron">
  <h1 class="display-3">Keep track of your maintenance</h1>
  <p class="lead">
    Stay on top of your regular maintenance intervals to keep your car in tip-top shape. Organize your receipts and
    notes to streamline repairs. Wow future buyers with complete maintenance history.
  </p>
  <p class="lead">
    <a class="btn btn-primary btn-lg" routerLink="/fleet">Get started</a>
  </p>
</div>